import { AuthModel, AuthRequestModel } from "@tsin-core/models/auth.model";

const ACTION_SCOPE = '[Auth]';

export class AuthenticateAction {
  static readonly type = `${ACTION_SCOPE} Login`;
  constructor(public payload: AuthRequestModel) { }
}

export class LogoutAction {
  static readonly type = `${ACTION_SCOPE} Logout`;
}

export class GetProfileAction {
  static readonly type = `${ACTION_SCOPE} Get Profile`;
}

export class SetLoading {
  static readonly type = `${ACTION_SCOPE} Set Loading`;
  constructor(public loading: boolean) { }
}

export class SetError {
  static readonly type = `${ACTION_SCOPE} Set Error`;
  constructor(public error: string | null) { }
}

export class ValidateTokenAction {
  static readonly type = `${ACTION_SCOPE} Validate Token`;
  constructor(public payload: { token: string; refreshToken: string }) { }
}

export class RefreshTokenAction {
  static readonly type = `${ACTION_SCOPE} Refresh Token`;
  constructor(public payload: { refreshToken: string }) { }
}

/**
 * Directly set auth state from Cognito token exchange response.
 * Bypasses the PRO backend /user/me call so the auth guard passes immediately.
 */
export class SetAuthAction {
  static readonly type = `${ACTION_SCOPE} Set Auth`;
  constructor(public payload: { token: string; refreshToken: string | null; user: any }) { }
}
